import { processApi } from '../../../utility/index'
import moment from 'moment'
import { emailRule } from '@/utility/index.js'
import tree from '../../../components/tree.vue'
import iTable from '../../../components/Table.vue'
import IPagination from '../../../components/pagination.vue'
export default {
  name: 'CompanyManagement',
  components: {
    tree,
    iTable,
    IPagination,
  },
  data() {
    return {
      isCollapse: false,
      formInline: {
        companyNum: '',
        name: '',
      },
      height: '550',
      list: [],
      option: {
        stripe: true,
        border: true,
        loading: false,
        highlightCurrentRow: false,
        mutiSelect: true,
        serialNumber: true,
      },
      columns: [
        {
          prop: 'companyNum',
          label: this.$t('CompanyManagement.companyNum'),
          align: 'center',
          width: '260px',
        },
        {
          prop: 'name',
          label: this.$t('CompanyManagement.name'),
          align: 'center',
          width: '260px',
        },
        {
          prop: 'loginName',
          label: this.$t('CompanyManagement.loginName'),
          align: 'center',
          width: '180px',
        },
        {
          prop: 'safeLoginName',
          label: this.$t('CompanyManagement.safeLoginName'),
          align: 'center',
          width: '180px',
        },
        {
          prop: 'createTime',
          label: this.$t('CompanyManagement.createTime'),
          align: 'center',
          width: '260px',
        },
        {
          prop: 'updateTime',
          label: this.$t('CompanyManagement.updateTime'),
          align: 'center',
          width: '260px',
        },
        {
          prop: 'lastUser',
          label: this.$t('CompanyManagement.lastUser'),
          align: 'center',
          width: '160px',
        },
      ],
      operates: {
        width: 100,
        fixed: 'right',
        list: [
          {
            id: '1',
            show: true,
            icon: 'iconfont iconicon-chakanxq',
            plain: true,
            disabled: false,
            method: (index, row) => {
              console.log(row)
              this.dialogFormVisible = true
              this.diaTitle = this.$t('common.btn.operate')
              this.btnType = 'operate'
              this.show = true
              this.disabled = true
              this.isDisabled = true
              this.id = row.id
              this.userId = row.userId
              this.safeUserId = row.safeUserId
              this.form.rolePower = row.rolePower
              this.getOneCompany()
              this.getRole()
            },
          },
        ],
      },
      roleList: [],
      id: '',
      userId: '',
      safeUserId: '',
      currentPage: 1,
      pageSize: 10,
      total: 1,
      selected: [],
      formLabelWidth: '140px',
      btnType: '',
      diaTitle: '',
      dialogFormVisible: false,
      rules: {
        name: [{ required: true, message: this.$t('CompanyManagement.form.name'), trigger: 'blur' }],
        homepageUrlNumber: [
          { required: true, message: this.$t('CompanyManagement.form.homepageUrlNumber'), trigger: 'change' },
        ],
        companyNum: [
          {
            required: true,
            message: this.$t('CompanyManagement.form.name'),
            trigger: 'blur',
          },
        ],
        loginName: [
          { required: true, message: this.$t('CompanyManagement.form.loginName'), trigger: 'blur' },
        ],
        userName: [
          { required: true, message: this.$t('CompanyManagement.form.userName'), trigger: 'blur' },
        ],
        email: [{ required: true, validator: emailRule, trigger: 'blur' }],
        safeLoginName: [
          { required: true, message: this.$t('CompanyManagement.form.safeLoginName'), trigger: 'blur' },
        ],
        safeUserName: [
          { required: true, message: this.$t('CompanyManagement.form.safeUserName'), trigger: 'blur' },
        ],
        safeEmail: [{ required: true, validator: emailRule, trigger: 'blur' }],
      },
      form: {
        name: '',
        homepageUrlNumber: '',
        companyNum: '',
        companyAddress: '',
        logoPath: '',
        loginName: '',
        userName: '',
        email: '',
        safeLoginName: '',
        safeEmail: '',
        safeUserName: '',
        rolePower: '',
        responsibleName: '',
        responsiblePhone: '',
        phone: '',
        safePhone: '',
      },
      urlList: [],
      processImg: processApi,
      FileList: [],
      show: false,
      disabled: false,
      isDisabled: false,
      isShow: true,
      bindType: '',
      typeName: '',
      dialogTransferFormVisible: false,
      LabelWidth: '104px',
      TransferRules: {},
      TransferForm: {
        name: '',
        roleId: '',
      },
      isSearch: true,
      imageUrl: '',
      passType: '',
      outerVisible: false,
      innerVisible: false,
      resetPass: '',
      dialogRoleFormVisible: false,
      checkKeys: [],
      appCheckKeys: [],
      RoleForm: {
        menu: '',
        appMenu: '',
      },
      RoleRules: {},
      defaultProps: {
        children: 'children',
        label: 'zhName',
        disabled: 'disabled',
      },
      data: [],
      appData: [],
      rolePowerName: '',
      appRolePowerName: '',
      rolePower: '',
      longitude: '',
      latitude: '',
    }
  },
  created() {
    this.getHomeUrl()
    this.getCompany()
  },
  methods: {
    toggleSideBar() {
      this.isCollapse = !this.isCollapse
      this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
    },
    getCompany() {
      let param = {
        companyNum: this.formInline.companyNum,
        name: this.formInline.name,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      }
      this.$store
        .dispatch('CompanyManagement/GET_QUERYCOMPANY', param)
        .then((res) => {
          if (res) {
            if (res.data.code == 200) {
              this.list = res.data.data.list
              this.$refs.page.CommandTotal = res.data.data.total
            }
          }
        })
        .catch((err) => { })
    },
    onSearch() {
      this.$refs.page.CommandCurrentPage = 1
      this.currentPage = 1
      this.getCompany()
    },
    onClear() {
      this.formInline = {
        companyNum: '',
        name: '',
      }
      this.getCompany()
    },

    getOneCompany() {
      let param = {
        id: this.id,
      }
      this.$store
        .dispatch('CompanyManagement/GET_SELECTSINGLECOMPANY', param)
        .then((res) => {
          if (res) {
            if (res.data.code == 200) {
              this.form = res.data.data
              this.form.logoPath = res.data.data.logoPath
              this.imageUrl = res.data.data.logoPath
              this.rolePowerName = res.data.data.menuNode
              this.appRolePowerName = res.data.data.appMenuNode
            }
          }
        })
        .catch((err) => { })
    },

    getRole() {
      this.$store
        .dispatch('roleManagement/GET_SELECTTEMPLATEROLE', {})
        .then((res) => {
          if (res) {
            if (res.data.code == 200) {
              this.roleList = res.data.data
            }
          }
        })
        .catch((err) => { })
    },

    addCompany() {
      this.dialogFormVisible = true
      this.diaTitle = this.$t('common.btn.add')
      this.btnType = 'add'
      this.show = false
      this.disabled = false
      this.isDisabled = false
      this.$nextTick(() => {
        this.$refs.form.resetFields()
        this.FileList = []
        this.form.name = ''
        this.form.logoPath = ''
        this.imageUrl = ''
      })
    },
    editCompany() {
      this.dialogFormVisible = true
      this.diaTitle = this.$t('common.btn.edit')
      this.btnType = 'edit'
      this.show = false
      this.disabled = true
      this.isDisabled = false
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
        this.form.name = this.selected[0].name
        this.form.homepageUrlNumber = this.selected[0].homepageUrlNumber
        this.form.companyNum = this.selected[0].companyNum
        this.form.companyAddress = this.selected[0].companyAddress
        this.form.responsibleName = this.selected[0].responsibleName
        this.form.responsiblePhone = this.selected[0].responsiblePhone
        this.form.loginName = this.selected[0].loginName
        this.form.userName = this.selected[0].userName
        this.form.email = this.selected[0].email
        this.form.safeLoginName = this.selected[0].safeLoginName
        this.form.safeUserName = this.selected[0].safeUserName
        this.form.safeEmail = this.selected[0].safeEmail
        this.form.phone = this.selected[0].phone
        this.form.safePhone = this.selected[0].safePhone
        this.form.logoPath = this.selected[0].logoPath
        this.imageUrl = this.selected[0].logoPath
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.btnType == 'add') {
            let param = {
              name: this.form.name,
              homepageUrlNumber: this.form.homepageUrlNumber,
              companyNum: this.form.companyNum,
              companyAddress: this.form.companyAddress,
              responsibleName: this.form.responsibleName,
              responsiblePhone: this.form.responsiblePhone,
              loginName: this.form.loginName,
              userName: this.form.userName,
              email: this.form.email,
              safeLoginName: this.form.safeLoginName,
              safeUserName: this.form.safeUserName,
              safeEmail: this.form.safeEmail,
              phone: this.form.phone,
              safePhone: this.form.safePhone,
              logoPath: this.form.logoPath,
            }
            this.$store
              .dispatch('CompanyManagement/GET_ADDCOMPANY', param)
              .then((res) => {
                if (res.data.code == 200) {
                  this.$message.success(this.$t('common.btn.addSuccess'))
                  this.dialogFormVisible = false
                  this.getCompany()
                  this.closeDia()
                } else {
                  this.$message.error(res.data.msg)
                }
              })
              .catch((err) => { })
          } else if (this.btnType == 'edit') {
            let param = {
              id: this.selected[0].id,
              name: this.form.name,
              homepageUrlNumber: this.form.homepageUrlNumber,
              companyNum: this.form.companyNum,
              companyAddress: this.form.companyAddress,
              responsibleName: this.form.responsibleName,
              responsiblePhone: this.form.responsiblePhone,
              loginName: this.form.loginName,
              userName: this.form.userName,
              email: this.form.email,
              safeLoginName: this.form.safeLoginName,
              safeUserName: this.form.safeUserName,
              safeEmail: this.form.safeEmail,
              phone: this.form.phone,
              safePhone: this.form.safePhone,
              logoPath: this.form.logoPath,
            }
            this.$store
              .dispatch('CompanyManagement/GET_UPDATECOMPANY', param)
              .then((res) => {
                if (res.data.code == 200) {
                  this.$message.success(this.$t('common.btn.editSuccess'))
                  this.dialogFormVisible = false
                  this.getCompany()
                  this.closeDia()
                } else {
                  this.$message.error(res.data.msg)
                }
              })
              .catch((err) => { })
          } else {
            let param = {
              id: this.id,
              rolePower: this.form.rolePower
              // menu: this.$refs.tree.getCheckedKeys().join(','),
              // appMenu: this.$refs.appTree.getCheckedKeys().join(','),
            }
            this.$store
              .dispatch('CompanyManagement/GET_UPDATECOMPANYROLE', param)
              .then((res) => {
                if (res.data.code == 200) {
                  this.$message.success(this.$t('common.btn.editSuccess'))
                  this.dialogFormVisible = false
                  this.getCompany()
                  this.closeDia()
                } else {
                  this.$message.error(res.data.msg)
                }
              })
              .catch((err) => { })
          }
        } else {
          return false
        }
      })
    },
    cancle(formName) {
      this.dialogFormVisible = false
      this.form = {
        name: '',
        homepageUrlNumber: '',
        companyNum: '',
        companyAddress: '',
        responsibleName: '',
        responsiblePhone: '',
        logoPath: '',
        loginName: '',
        userName: '',
        email: '',
        safeLoginName: '',
        safeEmail: '',
        safeUserName: '',
        phone: '',
        safePhone: '',
        rolePower: ''
      }
    },
    closeDia() {
      this.form = {
        name: '',
        homepageUrlNumber: '',
        companyNum: '',
        companyAddress: '',
        responsibleName: '',
        responsiblePhone: '',
        logoPath: '',
        loginName: '',
        userName: '',
        email: '',
        safeLoginName: '',
        safeEmail: '',
        safeUserName: '',
        phone: '',
        safePhone: '',
        rolePower: ''
      }
      this.dialogFormVisible = false
    },
    handleAvatarSuccess(res, file) {
      const arr = []
      this.FileList.push({
        url: res,
      })
      this.FileList.map((item) => {
        arr.push(item.url)
      })
      this.imageUrl = URL.createObjectURL(file.raw)
      this.form.logoPath = arr.join('')
    },
    handleRemove(file, fileList) { },
    getHomeUrl() {
      this.$store
        .dispatch('DictionaryManaged/GET_SELECTHOMEPAGEURL', {})
        .then((res) => {
          if (res) {
            if (res.data.code == 200) {
              this.urlList = res.data.data
            }
          }
        })
        .catch((err) => { })
    },

    transferCar() {
      this.dialogTransferFormVisible = true
      this.TransferForm.name = this.selected[0].name
      this.roleId = this.selected[0].orgId

      console.log(this.selected[0].orgId)

      if (this.roleId !== 0 && this.roleId) {
        this.isShow = false
        this.bindType = 0
        this.typeName = this.$t('common.btn.unBind')
      } else {
        this.isShow = true
        this.bindType = 1
        this.typeName = this.$t('common.btn.bind')
      }

      // if (this.roleId!==0&&this.roleId) {
      //     this.isShow = true
      //     this.bindType = 1
      //     this.typeName = '绑定'
      // } else {
      //     this.isShow = false
      //     this.bindType = 0
      //     this.typeName = '解绑'
      // }
    },
    changeClick(val) {
      this.roleId = val.label
    },
    submitTransferForm(TransferFormName) {
      this.$refs[TransferFormName].validate((valid) => {
        if (valid) {
          let param = {
            bindType: this.bindType,
            id: this.selected[0].id,
            name: this.TransferForm.name,
            orgId: this.roleId,
          }
          this.$store
            .dispatch('CompanyManagement/GET_COMPANYBINDORG', param)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message.success(res.data.data)
                this.dialogTransferFormVisible = false
                this.getCompany()
                this.closeTransfer()
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch((err) => { })
        } else {
          return false
        }
      })
    },
    cancleTransfer(TransferFormName) {
      this.dialogTransferFormVisible = false
      this.TransferForm = {
        name: '',
        roleId: '',
      }
    },
    closeTransferDia() {
      this.TransferForm = {
        name: '',
        roleId: '',
      }
      this.dialogTransferFormVisible = false
    },
    deleteCompany() {
      this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'), {
        cancelButtonText: this.$t('common.btn.cancel'),
        confirmButtonText: this.$t('common.btn.confirm'),
        type: 'warning',
      })
        .then((res) => {
          let param = { id: this.selected[0].id }
          this.$store
            .dispatch('CompanyManagement/GET_DELETECOMPANY', param)
            .then((response) => {
              if (response.data.code == 200) {
                this.getCompany()
                this.$message.success(this.$t('common.btn.deleteSuccess'))
              } else {
                this.$message.error(response.data.msg)
              }
            })
            .catch((error) => { })
        })
        .catch((err) => { })
    },

    handleSelectionChange(val) {
      this.selected = val
    },
    changeSize(item) {
      this.pageSize = item.pageSize
      this.currentPage = item.pageNum
      this.getCompany()
    },

    changePass() {
      this.$confirm(this.$t('JurisdictionalManagement.resetTip'), this.$t('common.btn.hint'), {
        cancelButtonText: this.$t('common.btn.cancel'),
        confirmButtonText: this.$t('common.btn.confirm'),
        type: 'warning',
      })
        .then((res) => {
          let param = { id: this.userId }
          this.$store
            .dispatch('userManagement/GET_RESETPASSWORD', param)
            .then((res) => {
              if (res.data.code == 200) {
                this.getCompany()
                this.dialogFormVisible = false
                this.$message.success({
                  message: res.data.data,
                  duration: 6000,
                })
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch((error) => { })
        })
        .catch((err) => { })
    },
    changeSafePass() {
      this.$confirm(this.$t('JurisdictionalManagement.resetTip'), this.$t('common.btn.hint'), {
        cancelButtonText: this.$t('common.btn.cancel'),
        confirmButtonText: this.$t('common.btn.confirm'),
        type: 'warning',
      })
        .then((res) => {
          let param = { id: this.safeUserId }
          this.$store
            .dispatch('userManagement/GET_RESETPASSWORD', param)
            .then((res) => {
              if (res.data.code == 200) {
                this.getCompany()
                this.dialogFormVisible = false
                this.$message.success({
                  message: res.data.data,
                  duration: 6000,
                })
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch((error) => { })
        })
        .catch((err) => { })
    },

    // getMenu() {
    //   this.$store.dispatch('tree/GET_GETMENUNODE', {}).then((res) => {
    //     if (res) {
    //       if (res.data.code == 200) {
    //         this.data = res.data.data
    //       }
    //     }
    //   })
    // },
    // getAppMenu() {
    //   this.$store.dispatch('tree/GET_GETAPPMENUNODE', {}).then((res) => {
    //     if (res) {
    //       if (res.data.code == 200) {
    //         this.appData = res.data.data
    //       }
    //     }
    //   })
    // },
    // changeRole() {
    //   this.dialogRoleFormVisible = true
    //   this.$nextTick(() => {
    //     this.getMenu()
    //     this.getAppMenu()
    //     this.$refs.RoleForm.clearValidate()
    //     this.RoleForm.menu = this.rolePowerName
    //     this.RoleForm.appMenu = this.appRolePowerName
    //     this.checkKeys = []
    //     this.appCheckKeys = []
    //     if (this.RoleForm.menu) {
    //       var txt = this.rolePowerName.split(',')
    //       txt.map((item, index) => {
    //         this.checkKeys.push(item)
    //       })
    //       this.$refs.tree.setCheckedKeys(this.checkKeys)
    //     }
    //     if (this.RoleForm.appMenu) {
    //       var txts = this.appRolePowerName.split(',')
    //       txts.map((items, k) => {
    //         this.appCheckKeys.push(items)
    //       })
    //       this.$refs.appTree.setCheckedKeys(this.appCheckKeys)
    //     }
    //   })
    // },
    // closeRoleDia() {
    //   this.dialogRoleFormVisible = false
    // },
    // submitRoleForm(RoleFormName) {
    //   this.$refs[RoleFormName].validate((valid) => {
    //     if (valid) {
    //       let param = {
    //         id: this.id,
    //         menu: this.$refs.tree.getCheckedKeys().join(','),
    //         appMenu: this.$refs.appTree.getCheckedKeys().join(','),
    //       }
    //       this.$store
    //         .dispatch('CompanyManagement/GET_UPDATECOMPANYROLE', param)
    //         .then((res) => {
    //           if (res.data.code == 200) {
    //             this.$message.success(this.$t('common.btn.editSuccess'))
    //             this.dialogRoleFormVisible = false
    //             this.dialogFormVisible = false
    //             this.getCompany()
    //             this.closeRoleDia()
    //           } else {
    //             this.$message.error(res.data.msg)
    //           }
    //         })
    //         .catch((err) => {})
    //     } else {
    //       return false
    //     }
    //   })
    // },
    // cancleRoleForm() {
    //   this.dialogRoleFormVisible = false
    // },
    onResize: function (x, y, width, height) {
      let box = document.getElementById('leftBox')
      box.style.width = width + 'px'
    },
  },
}
